export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
          {/* Photo - Desktop only */}
          <div className="hidden md:block flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 overflow-hidden border border-[#000000]">
              <img
                src="https://public.readdy.ai/ai/img_res/fbf5c29c-4e2c-48e1-abb6-d71f077349f5.png"
                alt="Andrea Disanto"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left space-y-4">
            <div className="space-y-2">
              <div className="inline-block px-3 py-1.5 bg-white border-2 border-[#000000] text-[#000000] text-xs font-semibold whitespace-nowrap">
                CHI SONO
              </div>

              {/* Photo - Mobile only, after "CHI SONO" and before name */}
              <div className="md:hidden flex justify-center pt-4 pb-2">
                <div className="w-32 h-32 overflow-hidden border border-[#000000]">
                  <img
                    src="https://public.readdy.ai/ai/img_res/fbf5c29c-4e2c-48e1-abb6-d71f077349f5.png"
                    alt="Andrea Disanto"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-[#000000]">
                Andrea Disanto
              </h2>

              <p className="text-base md:text-lg text-[#2563eb] font-semibold">
                Consulente Ads e Performance Marketing
              </p>
            </div>

            <p className="text-base text-gray-700 leading-relaxed">
              Gestisco da <strong>10 anni campagne Google Ads, Meta Ads, TikTok Ads e LinkedIn</strong>. Dopo <strong>aver lavorato per Google</strong>, ho guidato l'area marketing e performance in diverse agenzie tra Ferrara, Milano e Bari. Oggi affianco direttamente le <strong>aziende italiane</strong>, portando competenze enterprise con un approccio diretto, flessibile e senza i costi di struttura delle agenzie.
            </p>

            <div className="bg-gray-50 border-l-4 border-[#2563eb] p-4 md:p-6">
              <div className="text-sm md:text-base text-gray-700 space-y-3">
                <p>
                  Le campagne fanno il <strong>50% del lavoro.</strong>
                </p>
                <p>
                  L'altra metà la fa una <strong>Landing Page progettata per convertire.</strong>
                </p>
                <p>
                  Grazie a strumenti AI e ad un metodo collaudato nel tempo, realizziamo landing page personalizzate in tempi rapidi, mantenendo i costi sotto controllo.
                </p>
                <p>
                  Oggi il prezzo medio di una landing page in Italia supera i 600€.<br />
                  La nostra parte da&nbsp;<strong>489€ IVA inclusa</strong>, senza compromessi su qualità e performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}